/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Split_RowInputs */

const en_ui_studio_marker_split_row = /** @type {(inputs: Ui_Studio_Marker_Split_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split point`)
};

const de_ui_studio_marker_split_row = /** @type {(inputs: Ui_Studio_Marker_Split_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilungspunkt`)
};

/**
* | output |
* | --- |
* | "Split point" |
*
* @param {Ui_Studio_Marker_Split_RowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_split_row = /** @type {((inputs?: Ui_Studio_Marker_Split_RowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Split_RowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_split_row(inputs)
	return de_ui_studio_marker_split_row(inputs)
});